import React from 'react';
import { Tooltip } from 'react-tooltip';
import { ReactComponent as InfoIcon } from './info.svg';
import css from './Bubble.module.css';

const Map = {
    search: {
        text: "Buying",
        backgroundColor: "#c7e897",
        color: "#141414",
    },
    sell: {
        text: "Selling",
        backgroundColor: "#F9DE7B",
        color: "#141414",
    },
    introduced: {
        text: "Introduced",
        backgroundColor: "#3ccfb2",
        color: "#00674F",
    },
    meetingRequested: {
        text: "Introduction requested",
        backgroundColor: "#C9C7D3",
        color: "#515055",
    },
    closed: {
        text: "Chat closed",
        backgroundColor: "#FDD1D1",
        color: "#613C3C",
        // backgroundColor: "#E8E8E8",
        // color: "#666666",
    },
    rejected: {
        text: "Chat rejected",
        backgroundColor: "#FDD1D1",
        color: "#613C3C",
    },
    formFilled: {
        text: "Application form filled",
        backgroundColor: "#FDD59C",
        color: "#7B674B",
    },
};

const tooltipText = {
    introduced: "You can now share names, telephone numbers, emails, documents and photos.",
    meetingRequested: "An introduction with the counterparty has been requested.",
    closed: "This conversation has been closed.",
    rejected: "This conversation was rejected",
    formFilled: "An new enquiry message from a member.",
};

const Bubble = (props) => {
    const { type, withInfo } = props;
    const { text, backgroundColor, color } = Map[type] || {};

    const theText = tooltipText[type] || "";

    return <div
        className={css.root}
        style={{
            backgroundColor,
            color,
        }}
    >
        {text}
        {withInfo ? <div
            className={css.info}
            data-tooltip-id="info-tooltip"
            data-tooltip-content={theText}
        >
            <InfoIcon />
            <Tooltip id="info-tooltip" />
        </div> : null}
    </div>
};

export default Bubble;
